export default __webpack_public_path__ + "images/49fddeedb55a6ab099560dd3801f0618.png";